import { ObjectSchema, array, mixed, number, object, string } from 'yup';
import { Answer, ErrorMessage } from '../enums';
import { QuestionnaireFormValues } from '../types/form';
import { validateHeight, validateWeight } from '@/utils/validators';

export const questionnaireSchema: ObjectSchema<QuestionnaireFormValues> =
  object({
    height: number()
      .transform((_, val) => (val ? Number(val) : undefined))
      .required(ErrorMessage.Required)
      .test('validate-height', ErrorMessage.Height, (value) => {
        return validateHeight(value);
      }),
    weight: number()
      .transform((_, val) => (val ? Number(val) : undefined))
      .required(ErrorMessage.Required)
      .test('validate-weight', ErrorMessage.Weight, (value) => {
        return validateWeight(value);
      }),
    declarations: array(
      object({
        id: string().required(ErrorMessage.Required),
        header: string().required(ErrorMessage.Required),
        answer: mixed<Answer>()
          .oneOf(Object.values(Answer))
          .required(ErrorMessage.Required),
      }),
    ).required(ErrorMessage.Required),
  });
